import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { MapsAllModule } from '@syncfusion/ej2-angular-maps';
import { ToastModule } from '@syncfusion/ej2-angular-notifications';
import { RowDDService } from '@syncfusion/ej2-angular-treegrid';
import { loadCldr, setCulture, setCurrencyCode } from '@syncfusion/ej2-base';
import { AppComponent } from './app.component';
import { APP_ROUTES } from './app.route';
import { EparcoursComponentsModule } from './common/eparcours-components/eparcours-components.module';
import { MenuModule } from './common/menu/menu.module';
import { NotificationToastComponent } from './common/notification-toast/notification-toast.component';
import { PopinDialogModule } from './common/popin-dialog/popin-dialog.module';
import { AutoLogoutOnInactivityDirective } from './directives/auto-logout-on-inactivity.directive';
import { SyncfusionLocalizationService } from './i18n/syncfusion-localization.service';
import { SyncfusionTranslationModule } from './i18n/syncfusion-translation.module';
import { FrenchTranslation } from './i18n/translations/FR/syncfusion-french';
import { ClientInterceptorService } from './interceptors/client-interceptor.service';
import { DomainErrorInterceptorService } from './interceptors/domain-error-interceptor.service';
import { JwtInterceptorService } from './interceptors/jwt-interceptor.service';
import { NetcoreErrorInterceptorService } from './interceptors/netcore-error-interceptor.service';
import { NetcoreUnauthorizedErrorInterceptorService } from './interceptors/netcore-unauthorized-error-interceptor.service';
import { Other404ErrorInterceptorService } from './interceptors/other-404-error-interceptor.service';
import { Other500ErrorInterceptorService } from './interceptors/other-500-error-interceptor.service';
import { RefreshTokenInterceptorService } from './interceptors/refresh-token-interceptor.service';
import { TickHttpRequestInterceptorService } from './interceptors/tick-http-request-interceptor.service';
import { ExportBpfComponent } from './pages/export-bpf/export-bpf.component';
import { GestionTachesModule } from './pages/gestion-taches/gestion-taches.module';
import { configInitializerFactory } from './services/config/config.initializer';
import { ConfigService } from './services/config/config.service';
import { reducers } from './store/formulaires/reducers';
import { UtilsModule } from './utils/utils.module';

declare var require: any;
loadCldr(
  require('cldr-data/main/fr/ca-gregorian.json'),
  require('cldr-data/main/fr/timeZoneNames.json'),
  require('cldr-data/main/fr/numbers.json'),
  require('cldr-data/supplemental/numberingSystems.json'),
  require('cldr-data/main/fr/currencies.json'),
  require('cldr-data/supplemental/weekData.json'),
);
setCulture('fr');
setCurrencyCode('EUR');

@NgModule({
  declarations: [
    AppComponent,
    NotificationToastComponent,
    AutoLogoutOnInactivityDirective,
    ExportBpfComponent,
  ],

  imports: [
    BrowserModule,
    RouterModule.forRoot(APP_ROUTES, {
      anchorScrolling: 'enabled',
      onSameUrlNavigation: 'reload',
      scrollPositionRestoration: 'enabled',
      scrollOffset: [0, 130],
      enableTracing: false,
      paramsInheritanceStrategy: 'always'
    }),
    HttpClientModule,
    BrowserAnimationsModule,
    SyncfusionTranslationModule,
    CommonModule,
    FormsModule,
    ToastModule,
    UtilsModule,
    MenuModule,
    ReactiveFormsModule,
    PopinDialogModule,
    GestionTachesModule,
    MapsAllModule,
    EparcoursComponentsModule,
    StoreModule.forRoot(reducers),
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: configInitializerFactory,
      deps: [ConfigService],
      multi: true,
    },
    {provide: HTTP_INTERCEPTORS, useExisting: TickHttpRequestInterceptorService, multi: true},
    {provide: HTTP_INTERCEPTORS, useExisting: ClientInterceptorService, multi: true},
    {provide: HTTP_INTERCEPTORS, useExisting: RefreshTokenInterceptorService, multi: true},
    {provide: HTTP_INTERCEPTORS, useExisting: JwtInterceptorService, multi: true},
    {provide: HTTP_INTERCEPTORS, useExisting: DomainErrorInterceptorService, multi: true},
    {provide: HTTP_INTERCEPTORS, useExisting: NetcoreErrorInterceptorService, multi: true},
    {provide: HTTP_INTERCEPTORS, useExisting: Other500ErrorInterceptorService, multi: true},
    {provide: HTTP_INTERCEPTORS, useExisting: Other404ErrorInterceptorService, multi: true},
    {provide: HTTP_INTERCEPTORS, useExisting: NetcoreUnauthorizedErrorInterceptorService, multi: true},
    RowDDService
  ],
  bootstrap: [AppComponent],
  exports: [],
})
export class AppModule {
  constructor(syncfusionLocalizationService: SyncfusionLocalizationService) {
    syncfusionLocalizationService.loadTranslation(FrenchTranslation);
  }
}
